import { useAbsoluteDragNDrop } from '@shared/utils/composables/absolute-dran-n-drop'

export const initPinPMode = ({
  parentComponent,
  childComponent,
  paddingX,
  paddingY,
}: {
  parentComponent: HTMLElement
  childComponent: HTMLElement
  paddingX: number
  paddingY: number
}) => {
  const { onPointerDownHandler, onTouchStartHandler, onChangeScreenHandler, normalizePosition } = useAbsoluteDragNDrop({
    parent: parentComponent,
    child: childComponent,
    paddingX,
    paddingY,
  })
  childComponent.addEventListener('pointerdown', onPointerDownHandler)
  childComponent.addEventListener('touchstart', onTouchStartHandler)
  window.addEventListener('resize', onChangeScreenHandler)
  document.addEventListener('orientationchange', normalizePosition)
  normalizePosition()
  return () => {
    childComponent.removeEventListener('pointerdown', onPointerDownHandler)
    childComponent.removeEventListener('touchstart', onTouchStartHandler)
    window.removeEventListener('resize', onChangeScreenHandler)
    document.removeEventListener('orientationchange', normalizePosition)
    childComponent.style.removeProperty('left')
    childComponent.style.removeProperty('top')
    childComponent.style.removeProperty('bottom')
    childComponent.style.removeProperty('right')
  }
}
